(function($){
    'use strict';

    let isTouchScreen = (('createTouch' in document) || ('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
	let clickEvent = isTouchScreen ? 'touchstart' : 'click';

    let initLoadMore = function() {
        $('.mod_newslist .pagination').each(function(){
            let $pagination = $(this);
            let $newslist = $pagination.closest('.mod_newslist');
            let $button = $('<button>Ältere News</button>');
            let $next = $pagination.find('a.next');

            $pagination.children().hide();

            if ($next.length > 0) {
                $pagination.append($button);

                $button.on(clickEvent, function() {
                    $.ajax({
                        url: $next.attr('href'),
                        success: function (response) {
                            $newslist.append(response);
                            $pagination.remove();
                            initLoadMore();
                        },
                        complete: function() {
                            $pagination.remove();
                        }
                    });

                    return false;
                });
            }
        });
    };

    initLoadMore();
})(jQuery);
